import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useContext, useEffect, useState } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { useBookings } from 'app/hooks/data/core/extranet/bookings/useBookings';

import { ExtranetHeader } from '../../commons/ExtranetHeader/ExtranetHeader';

import { BookingDetailsRouter } from './BookingDetailsRouter';
import styles from './ExtranetBookings.module.scss';
import { ExtranetBookingsContent } from './_components/ExtranetBookingsContent';
import { useBookingCodeFromUrl } from './hooks/useBookingCodeFromUrl';
import { useBookingFilters } from './hooks/useBookingFilters';

const PAGE = 'Bookings';

export const ExtranetBookings = () => {
  const { hotelId } = useContext(HotelContext);
  const [bookingCode, setBookingCode] = useBookingCodeFromUrl();
  const [isLegacyBooking, setIsLegacyBooking] = useState<boolean | undefined>(
    undefined
  );
  const { packsList, oldPacksList } = useContext(ModernHotelContext);
  const packsLoaded = packsList.length > 0 || oldPacksList.length > 0;

  const {
    filters,
    searchInput,
    setSearchInput,
    updateFilters,
    handleDateChange,
  } = useBookingFilters();

  const [hasVccBookings, setHasVccBookings] = useState<boolean | undefined>(
    undefined
  );

  const areAllPackagesSelected =
    filters.packageIds !== undefined &&
    packsLoaded &&
    [...packsList, ...oldPacksList].every((pack) =>
      filters.packageIds?.includes(String(pack.id))
    );

  const { data: bookings, isLoading } = useBookings(
    hotelId,
    {
      ...filters,
      vccStatus: hasVccBookings ? filters.vccStatus : undefined,
      packageIds: areAllPackagesSelected ? undefined : filters.packageIds,
    },
    {
      enabled: packsLoaded,
    }
  );

  useEffect(() => {
    if (
      bookings?.hasVccBookings !== undefined &&
      hasVccBookings === undefined
    ) {
      setHasVccBookings(bookings.hasVccBookings);
    }
  }, [bookings?.hasVccBookings, hasVccBookings]);

  return (
    <Layout className={styles.extranetBookings}>
      <ExtranetHeader page={PAGE} />
      <Content className={styles.body}>
        <ExtranetBookingsContent
          bookings={bookings?.bookingsList.data ?? []}
          hasVccBookings={bookings?.hasVccBookings}
          isLoading={isLoading}
          filters={filters}
          updateFilters={updateFilters}
          pagination={bookings?.bookingsList.meta}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          handleDateChange={handleDateChange}
          setBookingCode={setBookingCode}
          setIsLegacyBooking={setIsLegacyBooking}
        />
        <BookingDetailsRouter
          bookingCode={bookingCode}
          onClose={() => setBookingCode(undefined)}
          isLegacyBooking={isLegacyBooking}
        />
      </Content>
    </Layout>
  );
};
